import { LogicType_Equals, LogicType_LessThan, LogicType_LessOrEquals, LogicType_GreaterThan, LogicType_In, LogicType_NotEquals, LogicType_GreaterOrEqual, LogicType_DeltaGreaterEquals, LogicType_DeltaLesserEquals, LogicType_DeltaEquals, LogicType_DeltaPercentageGreaterEquals, LogicType_DeltaPercentageLesserEquals, LogicType_DeltaPercentageEquals, LogicType_DeltaPercentageGreaterThan, LogicType_DeltaPercentageLesserThan, LogicType_DeltaGreaterThan, LogicType_DeltaLesserThan, LogicType_DeltaIn, LogicType_DeltaPercentageIn, LogicType_InSet, LogicType_InRange, LogicType_AboveRange, LogicType_BelowRange, LogicType_InNormal, LogicType_BelowNormal, LogicType_AboveNormal, LogicType_IsFalse, LogicType_IsTrue, LogicType_Delta, LogicType_DeltaPercentage, LogicType_Self, LogicType_NotInSet, } from '../atom-case-operator/index.js';
export const rangeRightHandOperators = [
    LogicType_Equals,
    LogicType_LessThan,
    LogicType_LessOrEquals,
    LogicType_GreaterThan,
    LogicType_In,
    LogicType_NotEquals,
    LogicType_GreaterOrEqual,
    LogicType_DeltaGreaterEquals,
    LogicType_DeltaLesserEquals,
    LogicType_DeltaEquals,
    LogicType_DeltaPercentageGreaterEquals,
    LogicType_DeltaPercentageLesserEquals,
    LogicType_DeltaPercentageEquals,
    LogicType_DeltaPercentageGreaterThan,
    LogicType_DeltaPercentageLesserThan,
    LogicType_DeltaGreaterThan,
    LogicType_DeltaLesserThan,
    LogicType_DeltaIn,
    LogicType_DeltaPercentageIn,
];
export const uniqueIdsRightHandOperators = [
    ...rangeRightHandOperators,
    LogicType_Equals,
    LogicType_InSet,
    LogicType_NotInSet,
    LogicType_NotEquals,
    LogicType_InRange,
    LogicType_AboveRange,
    LogicType_BelowRange,
    LogicType_InNormal,
    LogicType_BelowNormal,
    LogicType_AboveNormal,
    LogicType_IsFalse,
    LogicType_IsTrue,
    LogicType_Delta,
    LogicType_DeltaPercentage,
];
export const SelfOperators = [LogicType_Self, LogicType_Delta, LogicType_DeltaPercentage];
export const subTermsOperators = [LogicType_IsTrue, LogicType_IsFalse];
export const RightHandValues_NumericOperators = [
    LogicType_GreaterOrEqual,
    LogicType_GreaterThan,
    LogicType_LessOrEquals,
    LogicType_LessThan,
    LogicType_DeltaEquals,
    LogicType_DeltaGreaterEquals,
    LogicType_DeltaLesserEquals,
    LogicType_DeltaPercentageEquals,
    LogicType_DeltaPercentageGreaterEquals,
    LogicType_DeltaPercentageLesserEquals,
    LogicType_DeltaPercentageGreaterThan,
    LogicType_DeltaPercentageLesserThan,
    LogicType_DeltaGreaterThan,
    LogicType_DeltaLesserThan,
];
//# sourceMappingURL=consts.js.map